/**
 * Gives the display name for an environment used for things like Sentry
 * @param {String} currentHost
 * @example
 * // returns proj10
 * getEnvironmentDisplayName(proj10.retirementpartner.com)
 * @returns {String} Returns the display name for an environment
 */
export const getEnvironmentDisplayName = (currentHost) => {
    // if domain is proj[0-n] or uat[0-n] or cte[0-n] or cdemo[0-n] aws.gwl.com case insensitive
    let envDisplayName;

    const devEnvRegex =
        /(proj\d+)|(uat\d+\w+)|(uat\.)|(cte\d+)|(cdemo\d+)|(aws\.gwl\.com)|(^uat)|(qa)|(localhost)|(evaluate\d+)/i;

    const regexNames = currentHost.match(devEnvRegex);

    if (regexNames === undefined || regexNames === null) {
        envDisplayName = "Production";
    } else if (regexNames[0] === "uat.") {
        envDisplayName = "uat";
    } else {
        envDisplayName = regexNames[0];
    }
    return envDisplayName;
};
